import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Calendar, Popover, PopoverContent, PopoverTrigger } from '@monksflow/monks-ui';
import { CalendarDays } from 'lucide-react';
import { formatDateMask } from '@/entities/taxonomy';

/** Calendar-icon button for a date cell: opens a popover calendar and writes the
 *  picked date formatted to the field's mask (e.g. "YYYY" → "2026"). Independent
 *  of the grid's edit state — picking writes straight through `onChange`. */
export function DatePickerButton({
  mask,
  onChange,
}: {
  mask?: string | null;
  onChange: (v: string) => void;
}) {
  const { t } = useTranslation('knowledge');
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={t('taxonomy.fieldsEditor.openCalendar')}
          onMouseDown={(e) => e.stopPropagation()}
          className="shrink-0 text-muted-foreground hover:text-foreground"
        >
          <CalendarDays className="size-3.5" />
        </button>
      </PopoverTrigger>
      {/* Radix portals the content, but React synthetic events still bubble
          through the REACT tree into the grid cell's onMouseDown — which
          preventDefault()s the day click (no date written) and starts a
          drag-selection. Stop mouse/pointer events here so day clicks stay
          inside the calendar. */}
      <PopoverContent
        align="start"
        className="pointer-events-auto w-auto p-0"
        onMouseDown={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <Calendar
          mode="single"
          captionLayout="dropdown"
          onSelect={(next) => {
            if (next) {
              onChange(formatDateMask(next, mask));
              setOpen(false);
            }
          }}
        />
      </PopoverContent>
    </Popover>
  );
}
